import "jquery";

(<any>window).jQuery = (<any>window).$ = jQuery;